// Bump this when releasing a new version of the app.
export const APP_VERSION = '4.1.0'
